/** Bookmark management for the legacy page and the modern MVC list. */
(function() {
    'use strict';

    var mounts = typeof WeakMap === 'function' ? new WeakMap() : null;

    function t(key) {
        return window.t ? window.t(key) : key;
    }

    window.removeBookmark = function(item) {
        var url = $(item).attr('href');
        $.ajax({
            url: url,
            success: function() {
                $(item).closest('.bmProfBox').remove();
                var count = $('#bookmarkCount').text();
                count--;
                $('#bookmarkCount').text(count);
            }
        });
    };

    function mount(root) {
        if (!root) return function() {};
        if (mounts && mounts.has(root)) return mounts.get(root);

        var disposed = false;
        var pendingRows = [];
        var removalTimers = [];

        var disposeEditMode = window.ListManagement.initEditMode({
            root: root,
            deleteButtonClass: 'bookmark-delete-btn'
        });

        function isPending(card) {
            return pendingRows.indexOf(card) !== -1;
        }

        function setPending(card, pending) {
            var index = pendingRows.indexOf(card);
            if (pending && index === -1) pendingRows.push(card);
            if (!pending && index !== -1) pendingRows.splice(index, 1);
        }

        function updateBookmarkCount() {
            if (disposed) return;
            var container = root.querySelector('[data-bookmarks-container]');
            if (!container) return;
            if (container.querySelectorAll('[data-bookmark-card]').length !== 0) return;

            var template = root.querySelector('#bookmarks-empty-state') ||
                document.getElementById('bookmarks-empty-state');
            if (!template) return;
            var emptyState = template.content.cloneNode(true);
            var parent = container.parentNode;
            parent.replaceChild(emptyState, container);
            if (window.LucideIcons) window.LucideIcons.initialize(parent);
        }

        function removeBookmarkModern(button, bookmarkId, card) {
            window.ListManagement.removeItem({
                button: button,
                card: card,
                url: '/app/bookmarks/remove',
                formData: { bookmark: bookmarkId },
                errorMessage: t('common.remove_bookmark_error'),
                logPrefix: 'Bookmark removal',
                isActive: function() { return !disposed; },
                schedule: function(callback, delay) {
                    var timer = setTimeout(function() {
                        removalTimers.splice(removalTimers.indexOf(timer), 1);
                        callback();
                    }, delay);
                    removalTimers.push(timer);
                    return timer;
                },
                onSuccess: function() {
                    setPending(card, false);
                    updateBookmarkCount();
                }
            }).then(function(success) {
                if (!disposed && !success) setPending(card, false);
            });
        }

        function confirmRemoval(button, bookmarkId, username, card) {
            if (!card || isPending(card)) return;
            setPending(card, true);
            window.ListManagement.confirmAndRemove({
                title: t('common.remove_bookmark'),
                message: t('common.remove_bookmark_confirm').replace('{username}', username),
                fallbackMessage: t('common.remove_bookmark_fallback').replace('{username}', username),
                onConfirm: function() {
                    if (disposed) return;
                    removeBookmarkModern(button, bookmarkId, card);
                },
                onCancel: function() {
                    if (disposed) return;
                    setPending(card, false);
                }
            });
        }

        function handleDeleteClick(event) {
            var deleteButton = event.target.closest('.bookmark-delete-btn');
            if (!deleteButton || !root.contains(deleteButton)) return;
            event.preventDefault();
            event.stopPropagation();
            var card = deleteButton.closest('[data-bookmark-card]');
            confirmRemoval(
                deleteButton,
                deleteButton.dataset.bookmarkId,
                deleteButton.dataset.bookmarkUsername,
                card
            );
        }

        function handleSwipeAction(event) {
            var detail = event.detail;
            if (!detail || detail.action !== 'delete' || !root.contains(detail.row)) return;
            var card = detail.row;
            if (!card.hasAttribute('data-bookmark-card')) return;
            if (window.SwipeActions) window.SwipeActions.closeAll();
            confirmRemoval(detail.button, detail.id, card.dataset.bookmarkUsername, card);
        }

        function suppressDragClick(event) {
            if (!window.isDragging) return;
            var link = event.target.closest('[data-bookmark-card] a');
            if (link && root.contains(link)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }

        root.addEventListener('click', handleDeleteClick);
        root.addEventListener('swipe-action', handleSwipeAction);
        root.addEventListener('click', suppressDragClick, true);

        var dispose = function() {
            if (disposed) return;
            disposed = true;
            pendingRows.length = 0;
            removalTimers.forEach(clearTimeout);
            removalTimers.length = 0;
            root.removeEventListener('click', handleDeleteClick);
            root.removeEventListener('swipe-action', handleSwipeAction);
            root.removeEventListener('click', suppressDragClick, true);
            disposeEditMode();
            if (mounts) mounts.delete(root);
        };
        if (mounts) mounts.set(root, dispose);
        return dispose;
    }

    window.Bookmarks = { mount: mount };
})();
